module.exports = __webpack_public_path__ + "static/media/weissbeer-cup.d2bc0825.png";